import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "holder holder-fluid"
};
const _hoisted_2 = {
  class: "catalog",
  ref: "catalog"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EmptyResultComponent = _resolveComponent("EmptyResultComponent");

  const _component_AuthorCardComponent = _resolveComponent("AuthorCardComponent");

  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$data.authorsLoader.load && !$data.authors.length ? (_openBlock(), _createBlock(_component_EmptyResultComponent, {
    key: 0,
    title: $data.authorsLoader.title,
    description: $data.authorsLoader.description
  }, null, 8, ["title", "description"])) : _createCommentVNode("", true), _createVNode(_component_AuthorCardComponent, {
    authors: $data.authors
  }, null, 8, ["authors"]), _withDirectives(_createVNode(_component_SpinnerComponent, null, null, 512), [[_vShow, !$data.authorsLoader.load]])], 512)]);
}